exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".size-selector[data-v-dd618f36]{width:40px;height:40px}.size-selector[data-v-dd618f36]:hover,.size-selector[data-v-dd618f36]:focus{border-width:2px}.size-selector.active[data-v-dd618f36]{border-color:#18c05a;border-width:2px;color:#18c05a}.size-selector[data-v-dd618f36]:disabled{border-color:#a5a4a4;color:#a5a4a4;cursor:not-allowed}.size-selector[data-v-dd618f36]:disabled:hover,.size-selector[data-v-dd618f36]:disabled::after{border-width:1px}\n", ""]);

// exports
